import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=74ff1227&scoped=true"
import script from "./CouponManagement.vue?vue&type=script&lang=js"
export * from "./CouponManagement.vue?vue&type=script&lang=js"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=74ff1227&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff1227",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74ff1227')) {
      api.createRecord('74ff1227', component.options)
    } else {
      api.reload('74ff1227', component.options)
    }
    module.hot.accept("./CouponManagement.vue?vue&type=template&id=74ff1227&scoped=true", function () {
      api.rerender('74ff1227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/CouponManagement.vue"
export default component.exports